import React, {useCallback, useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import {
  Col,
  Row,
  Spin,
  VertButton,
  VertCarousel,
  VertContainer,
  VertTypography,
} from '@vertem-core/vertice-ds';
import MediaQuery from 'react-responsive';

import VertCardProductContainer from 'components/VertCardProductContainer/VertCardProductContainer';

import { useNavigate } from 'react-router';
import { stringToSlug } from 'Utils/stringToSlug';

import axios from 'axios';
import { showCaseApiURL } from 'Constants/Constants';
import useGA from "Utils/Ga";

const ShowcaseVoucherWrapper = ({ title, identifier, children }) => {
  const [showArrows, setShowArrows] = useState(null);
  const navigate = useNavigate();
  
  useEffect(() => {
    const slidesToShow = settings.slidesToShow;
    const isFewerItems = children?.length <= slidesToShow;

    setShowArrows(!isFewerItems);
  }, []);

  const settings = {
    slidesToShow: 4,
    arrows: showArrows,
    dots: false,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        },
      },
      {
        breakpoint: 790,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      },
    ],
  };

  return (
      <VertContainer fluid className="margin-bottom-big">
        <VertContainer
            data-testid="vert-box-showcase"
            className="vert-box-showcase margin-bottom-regular"
            spacingX="regular"
        >
          <Row
              justify="center"
              align="middle"
              className="vert-box-showcase-title padding-x-extra-small"
              gutter={8}
          >
            <Col flex="auto" className="vert-box-showcase-title-label">
              <MediaQuery maxWidth={768}>
                <VertTypography.Title level={2} className="margin-bottom-none">
                  {title}
                </VertTypography.Title>
              </MediaQuery>
              <MediaQuery minWidth={769}>
                <VertTypography.Title level={2} className="margin-bottom-none">
                  {title}
                </VertTypography.Title>
              </MediaQuery>
            </Col>
            <Col flex="none" className="vert-box-showcase-title-button">
              <VertButton
                  onClick={() => navigate(`/showcase/${identifier}`)}
                  type="link"
                  spacing="none"
                  size="small"
                  className="color-detached"
              >
                Mostrar todos
              </VertButton>
            </Col>
          </Row>
        </VertContainer>
        <VertContainer fluid className="vert-box-showcase padding-y-regular">
          <VertContainer spacingX="regular">
            <Row className="vert-showcase-wrapper" gutter={8}>
              <VertCarousel {...settings}
                ScrollToFirstItem
              >{children}</VertCarousel>
            </Row>
          </VertContainer>
        </VertContainer>
      </VertContainer>
  );
}

ShowcaseVoucherWrapper.propTypes = {
  title: PropTypes.string.isRequired,
  identifier: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
const ShowCaseAutomate = ({ idDisplayAreaId }) => {
  const userProfile = useSelector((state) => state.oidc.user.profile);
  const Catalog = useSelector(({ Catalog: data }) =>  data)
  const userInfos = useSelector(({ oidc: data }) => data);
  const [showcaseItems, setShowcaseItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ loadViewEvent, setLoadViewEvent ] = useState(false)
  const { eventGaUnlimited } = useGA()
  const {
    user: { access_token },
  } = userInfos;

  const headers = {
    campaignId: userProfile['custom:campaign_id'],
    catalogId: userProfile['custom:catalog_id'],
    participantId: userProfile['custom:participant_id'],
    Authorization: `Bearer ${access_token}`,
  };

  const setSelectItem = (identifier, title, item) => {
    eventGaUnlimited("select_item", {
      item_list_id: identifier,
      item_list_name: title,
      items: [
        {
          item_id: item.sku,
          item_name: item.name,
          currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
          item_brand: item.vendor.name,
          item_list_id: identifier,
          item_list_name: title,
          quantity: 1
        }
      ]
    })
  }

  const setViewEvent = useCallback((showcaseItems) => {
    if (loadViewEvent) return;
    setLoadViewEvent(true)
    showcaseItems.forEach((item) => {
      eventGaUnlimited("view_item_list", {
        item_list_id: item.identifier,
        item_list_name: item.title,
        items: item.products?.map(({ name, sku, vendor }) => ({
          item_id: sku,
          item_name: name,
          currency: Catalog?.currencyConfiguration?.pointsName?.toUpperCase(),
          item_brand: vendor.name,
          item_list_id: item.identifier,
          item_list_name: item.title,
          quantity: 1
        }))
      })
    })
  }, [loadViewEvent, Catalog])

  const { listAvaiabilityUnvaible } = useSelector(
      (state) => state.AutomateShowcase
  );
  const updateShowcaseItems = () => {
    const updatedShowcaseItems = showcaseItems.map((showcaseItem) => {
      const { availableProducts, unavailableProducts } =
          partitionProductsByAvailability(showcaseItem.products);

      const getOrderArray = showcaseItem.products.map((product) => product.sku);

      let availableProductsSortBySku = availableProducts.sort((a, b) => {
        return getOrderArray.indexOf(a.sku) - getOrderArray.indexOf(b.sku);
      });
    return {
        ...showcaseItem,
        products: [...unavailableProducts, ...availableProductsSortBySku],
      };
    });


    setShowcaseItems(updatedShowcaseItems);
  };

  const partitionProductsByAvailability = (products) => {
    const availableProducts = products.filter(
        (product) => !listAvaiabilityUnvaible.includes(product.sku)
    );
    const unavailableProducts = products.filter((product) =>
        listAvaiabilityUnvaible.includes(product.sku)
    );

    return { availableProducts, unavailableProducts };
  };

  const fetchShowcase = async () => {
    setLoading(true);
    await axios
        .get(
            `${showCaseApiURL}/Showcase/ActiveByDisplayArea/${idDisplayAreaId}`,
            {
              headers,
            }
        )
        .then((response) => {
          setShowcaseItems(response.data);

          setLoading(false);
        })
        .catch((error) => {
          console.error(error);
          setLoading(false);
        });
  };

  useEffect(() => {
    if (idDisplayAreaId) {
      fetchShowcase();
    }

    return () => {
      setShowcaseItems([]);
    };
  }, [idDisplayAreaId]);

  useEffect(() => {
    if (!listAvaiabilityUnvaible.length && !showcaseItems.length) return;
    updateShowcaseItems();
  }, [listAvaiabilityUnvaible]);

  useEffect(() => {
    if (showcaseItems.length > 0) {
      setViewEvent(showcaseItems);
    }
  }, [showcaseItems]);

  return (
      <Spin spinning={loading}>
        {showcaseItems.length > 0 &&
            showcaseItems?.map((item) =>
                item.products?.length > 0 ? (
                    <ShowcaseVoucherWrapper
                        title={item.title}
                        identifier={item.identifier}
                        key={item.id}
                    >
                      {item.products.map(
                          ({ imageUrl, name, originalId, type, sku, vendor }, index) => {
                            const product = {
                              colProps: {
                                className: 'col-12',
                              },
                              imageUrl,
                              productUrl: `/product/${sku}`,
                              showTimer: item.showTimer,
                              originalId: originalId,
                              name,
                              type,
                              sku,
                              vendor,
                              vendorId: vendor.id,
                              timerShowcase: {
                                startDate: new Date(),
                                endDate: item.finalDate,
                              },
                              showcaseName: stringToSlug(item?.title || ''),
                            };

                            return (
                                <div
                                    onClick={() => {
                                      setSelectItem(item.identifier, item.title, {
                                        vendor,
                                        sku,
                                        name
                                      })
                                    }}
                                    className="box-showcase-item"
                                >
                                  <VertCardProductContainer
                                      data-testid={`carousel-item-${index}`}
                                      key={originalId}
                                      cardProduct={product}
                                  />
                                </div>
                            );
                          }
                      )}
                    </ShowcaseVoucherWrapper>
                ) : null
            )}
      </Spin>
  );
};

ShowCaseAutomate.propTypes = {
  idDisplayAreaId: PropTypes.number.isRequired,
};

export default ShowCaseAutomate;
